"use strict";

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toRfaDto = exports.validateRFA = exports.schema = exports.validateRFAAddress = exports.addressSchema = exports.rfaContactSchema = exports.NON_EXISTING_CUSTOMER_ID = void 0;

var yup = __importStar(require("yup"));

var state_domain_1 = require("@solvana/state-domain");

var utils_1 = require("@solvana/domain-utils/dist/utils");

exports.NON_EXISTING_CUSTOMER_ID = 'non-existing-customer-id';
exports.rfaContactSchema = yup.object().shape({
  firstName: yup.string().trim().required(),
  lastName: yup.string().trim().required(),
  email: yup.string().trim().required(),
  phoneNumber: yup.string().trim().required()
});
exports.addressSchema = yup.object().shape({
  address1: yup.string().trim().required(),
  address2: yup.string().trim().nullable(),
  zip: yup.string().trim().required(),
  city: yup.string().trim().required(),
  state: yup.string().trim().oneOf(state_domain_1.STATE_VALUES).required()
}).required();
exports.validateRFAAddress = utils_1.checkValidity(exports.addressSchema);
exports.schema = yup.object().shape({
  customerId: yup.string().trim().required(),
  createdAt: yup.string().trim().required(),
  updatedAt: yup.string().trim().required(),
  rfaId: yup.string().trim().required(),
  referralId: yup.string().optional(),
  averageMonthlyBill: yup.number().min(0).optional(),
  proposalId: yup.number().min(1).optional(),
  doesNotQualify: yup["boolean"]()["default"](false),
  address: exports.addressSchema,
  contact: exports.rfaContactSchema.notRequired()["default"](undefined),
  survey: yup.array().of(yup.object().shape({
    question: yup.string().trim().required(),
    answers: yup.array().of(yup.string().trim().required()).min(1)
  })).optional()
});
exports.validateRFA = utils_1.checkValidity(exports.schema);

exports.toRfaDto = function (entity) {
  if (!entity) return null;
  return {
    customerId: entity === null || entity === void 0 ? void 0 : entity.customerId,
    rfaId: entity === null || entity === void 0 ? void 0 : entity.rfaId,
    address: entity === null || entity === void 0 ? void 0 : entity.address,
    contact: entity === null || entity === void 0 ? void 0 : entity.contact,
    survey: entity === null || entity === void 0 ? void 0 : entity.survey,
    createdAt: entity === null || entity === void 0 ? void 0 : entity.createdAt,
    updatedAt: entity === null || entity === void 0 ? void 0 : entity.updatedAt,
    doesNotQualify: entity === null || entity === void 0 ? void 0 : entity.doesNotQualify,
    proposalId: entity === null || entity === void 0 ? void 0 : entity.proposalId,
    referralId: entity === null || entity === void 0 ? void 0 : entity.referralId
  };
};